module.exports = __webpack_public_path__ + "img/xian.5f70b6d7.jpg";